module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/main-bg_65ed8870960a8ce65fb54061a57a9f72.jpg";